var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { OutlineFilter } from '@pixi/filter-outline';
import { createCache } from '@timeflies/cache';
import { Sprite } from 'pixi.js';
import { createTickerManager } from './ticker-manager';
var objectDeepEqual = function (objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (objA && objB && typeof objA === 'object' && typeof objB === 'object') {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        return keysA.length === keysB.length
            && keysA.every(function (key) { return objectDeepEqual(objA[key], objB[key]); });
    }
    return false;
};
var AnimatedComplexSprite = /** @class */ (function (_super) {
    __extends(AnimatedComplexSprite, _super);
    function AnimatedComplexSprite(spritesheet, framesInfos, ticker, cache) {
        if (cache === void 0) { cache = createCache(); }
        var _this = _super.call(this) || this;
        _this.animations = spritesheet.animations;
        _this.framesInfos = framesInfos;
        _this.currentTime = 0;
        _this.tickerManager = createTickerManager(_this.update.bind(_this), function () { return _this.tickerInterval; }, ticker);
        _this.cache = cache;
        _this.outlineFilter = new OutlineFilter(undefined, undefined, 1);
        _this.outlineFilter.enabled = false;
        _this.filters = [_this.outlineFilter];
        var _a = _this.getTexturesInfos(), timedTextures = _a.timedTextures, tickerInterval = _a.tickerInterval, previousFrame = _a.previousFrame;
        _this.timedTextures = timedTextures;
        _this.tickerInterval = tickerInterval;
        _this.previousFrame = previousFrame;
        _this.updateTexture(true);
        return _this;
    }
    AnimatedComplexSprite.prototype.getTimedTextures = function (rawTextures, framesOrder, framesDurations, pingPong) {
        var framedTextures = framesOrder.map(function (index) { return rawTextures[index - 1]; })
            .map(function (texture, frame) { return ({
            texture: texture,
            frame: frame,
            textureIndex: framesOrder[frame]
        }); });
        if (pingPong && framedTextures.length > 2) {
            framedTextures.push.apply(framedTextures, framedTextures.slice(1, framedTextures.length - 1).reverse());
        }
        return framedTextures.map(function (_a) {
            var texture = _a.texture, frame = _a.frame, textureIndex = _a.textureIndex;
            return ({
                texture: texture,
                duration: framesDurations[frame % framesDurations.length],
                textureIndex: textureIndex
            });
        });
    };
    AnimatedComplexSprite.prototype.getCurrentFrame = function () {
        var currentFrame = Math.floor(this.currentTime) % this.timedTextures.length;
        if (currentFrame < 0) {
            currentFrame += this.timedTextures.length;
        }
        return currentFrame;
    };
    AnimatedComplexSprite.prototype.getFinalFramesInfos = function () {
        var _a = this.framesInfos, flip = _a.flip, restInfos = __rest(_a, ["flip"]);
        if (flip) {
            var _b = flip.baseFramesInfos, innerFlip = _b.flip, flipFramesInfos = __rest(_b, ["flip"]);
            if (innerFlip) {
                throw new Error('Cannot use flip baseState also flipped');
            }
            return __assign(__assign({}, flipFramesInfos), { textureFlipFn: function (texture) {
                    var flippedTexture = texture.clone();
                    flippedTexture.rotate = flip.direction === 'horizontal' ? 12 : 8;
                    return flippedTexture;
                } });
        }
        return __assign(__assign({}, restInfos), { textureFlipFn: function (texture) { return texture; } });
    };
    AnimatedComplexSprite.prototype.getTexturesInfos = function () {
        var _this = this;
        return this.cache.getOrElse(this.framesInfos, function () {
            var _a = _this.getFinalFramesInfos(), animationPath = _a.animationPath, _b = _a.pingPong, pingPong = _b === void 0 ? false : _b, rawFramesOrder = _a.framesOrder, framesDurations = _a.framesDurations, textureFlipFn = _a.textureFlipFn;
            var rawTextures = _this.animations[animationPath];
            if (!rawTextures || !rawTextures.length) {
                throw new Error("Textures not found with animation path [" + animationPath + "]");
            }
            var textures = rawTextures.map(textureFlipFn);
            var framesOrder = rawFramesOrder !== null && rawFramesOrder !== void 0 ? rawFramesOrder : textures.map(function (t, i) { return i + 1; });
            var timedTextures = _this.getTimedTextures(textures, framesOrder, framesDurations, pingPong);
            var tickerInterval = AnimatedComplexSprite.durationToInterval(Math.min.apply(Math, timedTextures.map(function (t) { return t.duration; })));
            var infos = {
                timedTextures: timedTextures,
                tickerInterval: tickerInterval,
                previousFrame: 0
            };
            return infos;
        });
    };
    AnimatedComplexSprite.prototype.setFramesInfos = function (newFramesInfos, options) {
        if (options === void 0) { options = {}; }
        var _a = options.forceUpdate, forceUpdate = _a === void 0 ? false : _a, _b = options.keepTimeState, keepTimeState = _b === void 0 ? false : _b;
        if (!forceUpdate && objectDeepEqual(this.framesInfos, newFramesInfos)) {
            return;
        }
        this.framesInfos = newFramesInfos;
        var _c = this.getTexturesInfos(), timedTextures = _c.timedTextures, tickerInterval = _c.tickerInterval, previousFrame = _c.previousFrame;
        this.timedTextures = timedTextures;
        this.tickerInterval = tickerInterval;
        this.previousFrame = previousFrame;
        if (!keepTimeState) {
            this.currentTime = 0;
        }
        this.tickerManager.resetDeltaMsSum();
        this.updateTexture(true);
    };
    AnimatedComplexSprite.prototype.setOutline = function (outlineInfos) {
        var _a = outlineInfos !== null && outlineInfos !== void 0 ? outlineInfos : {}, _b = _a.thickness, thickness = _b === void 0 ? 0 : _b, _c = _a.color, color = _c === void 0 ? 0x000000 : _c;
        this.outlineFilter.thickness = thickness;
        this.outlineFilter.color = color;
        this.outlineFilter.padding = thickness;
        this.outlineFilter.enabled = thickness > 0;
    };
    AnimatedComplexSprite.prototype.play = function () {
        this.tickerManager.start();
    };
    AnimatedComplexSprite.prototype.getCurrentDuration = function () {
        return this.timedTextures[this.getCurrentFrame()].duration;
    };
    AnimatedComplexSprite.prototype.update = function (deltaMs) {
        var previousFrame = this.getCurrentFrame();
        var lag = this.currentTime % 1 * this.getCurrentDuration();
        lag += deltaMs;
        while (lag < 0) {
            this.currentTime--;
            lag += this.getCurrentDuration();
        }
        var sign = Math.sign(deltaMs);
        this.currentTime = Math.floor(this.currentTime);
        while (lag >= this.getCurrentDuration()) {
            lag -= this.getCurrentDuration() * sign;
            this.currentTime += sign;
        }
        this.currentTime += lag / this.getCurrentDuration();
        if (previousFrame !== this.getCurrentFrame()) {
            if (this.onLoop && previousFrame === this.timedTextures.length - 1) {
                this.onLoop();
            }
            this.updateTexture();
        }
    };
    AnimatedComplexSprite.prototype.updateTexture = function (force) {
        var currentFrame = this.getCurrentFrame();
        if (!force && this.previousFrame === currentFrame) {
            return;
        }
        this.previousFrame = currentFrame;
        this.texture = this.timedTextures[currentFrame].texture;
        this._cachedTint = 0xFFFFFF;
        if (this.onFrameChange) {
            this.onFrameChange(currentFrame, this.timedTextures[currentFrame].textureIndex);
        }
    };
    AnimatedComplexSprite.prototype.stop = function () {
        this.tickerManager.stop();
    };
    AnimatedComplexSprite.prototype.clearCache = function () {
        var _a;
        (_a = this.cache) === null || _a === void 0 ? void 0 : _a.clear();
    };
    AnimatedComplexSprite.prototype.destroy = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.stop();
        this.clearCache();
        _super.prototype.destroy.apply(this, args);
        delete this.onLoop;
        delete this.onFrameChange;
    };
    AnimatedComplexSprite.durationToInterval = function (duration) { return duration / 3; };
    return AnimatedComplexSprite;
}(Sprite));
export { AnimatedComplexSprite };
